import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme';

export const Disclaimer = styled.p`
  text-align: center;
  color: #848484;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  max-width: 335px;
  margin: 16px auto;

  & > span {
    cursor: pointer;
    text-decoration: underline;
    white-space: nowrap;
  }

  @media (min-width: ${({ theme }) => theme.desktopMinWidth}px) {
    max-width: 432px;
  }

  ${darkMode(css`
    color: ${darkPalette.textTertiary};
  `)}
`;
